import { apiCallJson } from './api';

/**
 * Fire-and-forget helper to mark an onboarding milestone as completed.
 * Components call this when the user does the action that defines a milestone
 * (e.g. running a keyword search, opening the Bid Optimizer).
 *
 * The call is intentionally non-blocking — onboarding is non-critical UX, so
 * a network error must never break the feature the user is actually using.
 *
 * Once-per-session deduplication via sessionStorage avoids spamming the API
 * when the user re-enters the same screen multiple times in a single session.
 */
export function trackOnboardingMilestone(milestoneId) {
  if (!milestoneId) return;
  try {
    const flagKey = `bidoryx_onboarding_event_${milestoneId}`;
    if (sessionStorage.getItem(flagKey) === '1') return;
    sessionStorage.setItem(flagKey, '1');
  } catch {
    // sessionStorage may be unavailable (private mode, SSR). Just skip dedup.
  }
  apiCallJson('/api/onboarding/track-event', {
    method: 'POST',
    body: { milestoneId }
  }).catch(() => { /* silent — see comment above */ });
}
